<div class="controls-container">
    <div class="controls-header">Sidenav</div>

    <div class="controls-sub-header">Sidenav</div>

    <div style="display: flex;height: 300px; width: 300px; border: 3px dotted #ccc; position: relative">


        <div style="pointer-events: none; position: absolute; align-items: center; display: flex; justify-content: center; height: 100%; width: 100%;"> Main Area </div>
        <pm-sidenav>
            <div>
                Okay Computer
            </div>
        </pm-sidenav>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/sidenav/sidenav.html